'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getPathForLocale } from '@whitbread-eos/utils';
import { getLocaleByPathname, useTranslation } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
export function WizardHeader({ logoUrl, steps }) {
    const pathname = usePathname();
    const locale = getLocaleByPathname(pathname);
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx("header", {
        className: headerStyle,
        children: /*#__PURE__*/ _jsxs("div", {
            className: headerContainerStyle,
            children: [
                /*#__PURE__*/ _jsx(Link, {
                    href: getPathForLocale(locale, 'homepage'),
                    "data-testid": "IB-Logo",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: logoUrl,
                        alt: t('content.header.imageAlt'),
                        className: logoStyle,
                        width: 160,
                        height: 48
                    })
                }),
                steps
            ]
        })
    });
}
const logoStyle = 'w-40 h-12 max-w-none';
const headerStyle = 'fixed mobile:static top-0 flex flex-col justify-center px-[4.125rem] py-4 border-b border-lightGrey3 h-headerHeight w-full bg-background mobile:h-auto mobile:px-4 z-40';
const headerContainerStyle = 'flex items-center justify-between mobile:flex-col mobile:items-start';
